import React from 'react';
import * as LI from 'lucide-react';
import { whyChoose } from '../mock';

export default function WhyChoose() {
  return (
    <section id="why" className="py-24 bg-gradient-to-b from-white to-teal-50/40 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="chip">Why Sleek Business</span>
            <h2 className="mt-5 text-4xl md:text-5xl font-bold text-[#0a2540] tracking-tight leading-[1.05]">
              The <span className="font-serif-display italic text-teal-600">smarter</span> way to fund your business
            </h2>
            <p className="mt-5 text-slate-600 text-lg leading-relaxed">
              We’ve built a finance experience that works with the natural rhythm of UK small business — flexible, transparent and genuinely on your side.
            </p>
            <div className="mt-8 p-6 rounded-2xl bg-white border border-slate-200 shadow-sm">
              <div className="flex items-center gap-4">
                <div className="flex -space-x-3">
                  {[1,2,3,4].map(n => (
                    <div key={n} className="h-10 w-10 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 border-2 border-white flex items-center justify-center text-white text-xs font-bold">
                      {['JW','PS','MB','SE'][n-1]}
                    </div>
                  ))}
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#0a2540]">10,000+ UK businesses funded</div>
                  <div className="text-xs text-slate-500">and counting every day</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {whyChoose.map((f) => {
              const Icon = LI[f.icon];
              return (
                <div key={f.title} className="tilt-card bg-white border border-slate-200 rounded-2xl p-6">
                  <div className="h-11 w-11 rounded-xl bg-[#0a2540] flex items-center justify-center text-teal-400">
                    {Icon && <Icon size={20}/>}
                  </div>
                  <h4 className="mt-5 text-lg font-semibold text-[#0a2540]">{f.title}</h4>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
